import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { AppointmentSection } from './components/AppointmentSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { ServicesSection } from './components/ServicesSection';
import { PageTransition } from './components/PageTransition';
import { AnimatedSection } from './components/AnimatedSection';
export function App() {
  return <PageTransition data-id="element-0">
      <div className="min-h-screen bg-[#f2f2ed]" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <AnimatedSection data-id="element-5">
            <AboutSection data-id="element-6" />
          </AnimatedSection>
          <AnimatedSection data-id="element-7">
            <ServicesSection data-id="element-8" />
          </AnimatedSection>
          <AnimatedSection data-id="element-9">
            <AppointmentSection data-id="element-10" />
          </AnimatedSection>
          <AnimatedSection data-id="element-11">
            <TestimonialsSection data-id="element-12" />
          </AnimatedSection>
          <AnimatedSection data-id="element-13">
            <ContactSection data-id="element-14" />
          </AnimatedSection>
        </main>
        <Footer data-id="element-15" />
      </div>
    </PageTransition>;
}